/**
 * @module builder
 */

import type { Contact, WisetackLoanApplication } from '@paintscout/api'
import type { QuoteDocument } from 'paintscout'

/**
 * Returns the loan application for a given estimate-invoice pair
 */
export const getQuoteLoanApplication = (args: {
  contact: Partial<Contact>
  quote: QuoteDocument
}): WisetackLoanApplication | null => {
  const { contact, quote } = args

  if (!contact?.wisetackLoanApplications?.length || !quote) {
    return null
  }

  // We'll reverse the order of the loan applications so that we can find the most recent one
  const reversedLoanApplications = [...contact.wisetackLoanApplications].reverse()

  const matchingLoanApplication = reversedLoanApplications.find((loanApplication) => {
    const purchaseId = loanApplication.purchaseId
    // Loan application is tied directly to the estimate/invoice
    if (purchaseId === quote._id) {
      return true
    }
    // Loan application is tied to the parent estimate of this invoice
    if (quote.is_invoice && purchaseId === quote.parent_quote) {
      return true
    }
    // Loan application is tied to a child invoice of this estimate
    if (
      !quote.is_invoice &&
      (purchaseId === quote.child_invoice || (quote.child_invoices ?? []).includes(purchaseId))
    ) {
      return true
    }
    return false
  })

  return matchingLoanApplication || null
}
